__turbopack_context__.v({
  "arrow": "styles-module-scss-module__4QXxrG__arrow",
  "card": "styles-module-scss-module__4QXxrG__card",
  "footer": "styles-module-scss-module__4QXxrG__footer",
  "hasPage": "styles-module-scss-module__4QXxrG__hasPage",
  "jobTitle": "styles-module-scss-module__4QXxrG__jobTitle",
  "logo": "styles-module-scss-module__4QXxrG__logo",
  "name": "styles-module-scss-module__4QXxrG__name",
});
